import React from "react";
import * as styles from "../../css/BlogDetails.module.css";
import RichTextRenderer from "../../../../utils/components/RichTextRenderer";
import BlogBanner from "./components/BlogBanner";
import AfterContent from "./components/AfterContent";
import Seo from "../../../../utils/components/seo";
import BlogInfo from "./components/BlogInfo";
import { Link } from "gatsby";
import { ProgressBar } from "@nadfri/react-scroll-progress-bar";

const BlogDetails = ({ pageContext }) => {
  const { blog } = pageContext || {};
  const { meta_description, meta_title } = blog || {};
  const { blog_tags } = blog || {};

  return (
    <>
      <Seo title={meta_title || "Blogs"} description={meta_description} />
      <div>
        <BlogBanner styles={styles} blog={blog} />
        <div className={styles?.blogSingleContentWrap}>
          <div className={styles?.blogSingleContent}>
            <BlogInfo
              blogTitle={blog?.blogTitle}
              blog_category={blog?.blog_category}
              styles={styles}
              readTime={blog?.readTime}
              PdfFile={blog?.pdf?.PdfFile}
              className={"desktop-hide"}
            />
            <div className={styles?.blogSingleContentItemsContainer}>
              <ProgressBar
                position={"fixed"}
                color2={"#009bff"}
                color1={"transparent"}
              />
              <div className={styles?.blogSingleContentItems}>
                <RichTextRenderer content={blog?.content} styles={styles} />
              </div>
              <div
                className={`${styles?.blogSingleContentCategoryWrap} mobile-hide`}
              >
                {blog_tags?.map((data, index) => {
                  const { tag, slug } = data;
                  return (
                    <Link
                      to={"/resources/blogs?tag=" + slug}
                      className={styles?.blogSingleContentCategory}
                      key={index}
                    >
                      {tag}
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <AfterContent blog={blog} blog_tags={blog_tags} styles={styles} />
      </div>
    </>
  );
};

export default BlogDetails;
